import { render, staticRenderFns } from "./ListProductItem.vue?vue&type=template&id=146ff65e&scoped=true&name=list-product-item&"
import script from "./ListProductItem.vue?vue&type=script&lang=js&"
export * from "./ListProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ListProductItem.vue?vue&type=style&index=0&id=146ff65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ff65e",
  null
  
)

/* custom blocks */
import block0 from "./ListProductItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports